import { firstName } from "../../../validations/yupValidations";
import { ICreateAndUpdateClient } from "../../../types/client.interface";
import customAxios from "../../customAxios";
import { UPDATE_CLIENT, UPDATE_ORDER } from "../../routes";
import { ICreateAndUpdateOrder } from "../../../types/order.interface";
// import { PAY_DEBT_BY_ADMIN_PUT } from "../../routes";

const updateOrder = async (props: ICreateAndUpdateOrder) => {
  const body = {
    address: {
      completeAddress: props.address?.completeAddress,
      lat: props.address?.lat,
      lng: props.address?.lng,
    },
    description: props.description,
    status: props.status,
  };

  try {
    return (await customAxios.patch(UPDATE_ORDER + `/${props._id}`, body)).data;
  } catch (error: unknown) {
    console.error({ UPDATE_CLIENT: error });
    return false;
  }
};

export default updateOrder;
